import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ErrorModal } from '../../../components/modals/error-modal';
import ModalPortal from '../../../components/modal-portal';
import messages from './messages';

const AccessDeniedModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <ErrorModal
        message={<FormattedMessage {...messages.message} />}
        modalFrameworkMethods={{ onClose }}
        title={<FormattedMessage {...messages.title} />}
      />
    </ModalPortal>
  );
};

AccessDeniedModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AccessDeniedModal;
